import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import {
  LucideAngularModule,
  LucideIconData,
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  Info,
} from 'lucide-angular';

/** Supported field message severities. */
export type FieldMessageType = 'error' | 'warning' | 'success' | 'info';

/**
 * Inline validation/help message with an icon matched to the message type.
 */
@Component({
  selector: 'app-field-message',
  imports: [LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './field-message.component.html',
  styleUrl: './field-message.component.css',
})
export class FieldMessageComponent {
  /** Severity used to choose color and icon treatment. */
  readonly type    = input<FieldMessageType>('error');
  /** Message text displayed beside the icon. */
  readonly message = input('');

  /** Icon that corresponds to the current message type. */
  readonly icon = computed<LucideIconData>(() => {
    switch (this.type()) {
      case 'warning': return AlertTriangle;
      case 'success': return CheckCircle;
      case 'info':    return Info;
      default:        return AlertCircle;
    }
  });
}
